import React from 'react';
import { useStyles } from '../../pages/styles';

interface IViewContainer { 
  children?: React.ReactNode;
  isButton?: boolean;
}

const ViewContainer: React.FC <IViewContainer> = (props) => {
  const globalStyle = useStyles();

  return <div className={props.isButton ? globalStyle.whiteContainerWithButton : globalStyle.whiteContainer}>{props.children}</div>;
};

export default ViewContainer;
